export default {
  organization: {},
  myWorkspaces: [],
  invitedWorkspaces: [],
  organizationMembers: [],
  invitedMembers: [],
  groups:[],
  loading: false,
}
